// Table of contents:
// 1 header
// 2 deliveryForecastInformation
// 3 dataForConfirmation
// 4 deliveryScheduleDetails
// 5 attachment
//  5.1 documents
//  5.2 additionalDocuments
// 6 editSplitItem
// 7 infoSplitItem
// 8 rejectSplitItem
// 9 acceptSplitItem
// 10 addSplitItem
// 11 acceptDeliveryForecast
import { DeliveryForecast } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createDeliveryForecast = (): DeliveryForecast => {
  return {
    // 1 header
    header: {
      enabled: true,
      title: getTranslationsForConfig('deliveryForecast.header.title'), // t('deliveryForecast.header.title')
      // buyer
      buyerInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecast.header.buyerInformation.title',
        ), // t('deliveryForecast.header.buyerInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.externalId',
          ), // t('deliveryForecast.header.buyerInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.company',
          ), // t('deliveryForecast.header.buyerInformation.labels.company')
        },
        department: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.department',
          ), // t('deliveryForecast.header.buyerInformation.labels.department')
        },
        name: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.name',
          ), // t('deliveryForecast.header.buyerInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.phone',
          ), // t('deliveryForecast.header.buyerInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.email',
          ), // t('deliveryForecast.header.buyerInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.address',
          ), // t('deliveryForecast.header.buyerInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.countryCode',
          ), // t('deliveryForecast.header.buyerInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.buyerInformation.labels.vatNumber',
          ), // t('deliveryForecast.header.buyerInformation.labels.vatNumber')
        },
      },
      // seller
      sellerInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecast.header.sellerInformation.title',
        ), // t('deliveryForecast.header.sellerInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.externalId',
          ), // t('deliveryForecast.header.sellerInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.company',
          ), // t('deliveryForecast.header.sellerInformation.labels.company')
        },
        department: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.department',
          ), // t('deliveryForecast.header.sellerInformation.labels.department')
        },
        name: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.name',
          ), // t('deliveryForecast.header.sellerInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.phone',
          ), // t('deliveryForecast.header.sellerInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.email',
          ), // t('deliveryForecast.header.sellerInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.address',
          ), // t('deliveryForecast.header.sellerInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.countryCode',
          ), // t('deliveryForecast.header.sellerInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.sellerInformation.labels.vatNumber',
          ), // t('deliveryForecast.header.sellerInformation.labels.vatNumber')
        },
      },
      // shipping
      shippingInformation: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecast.header.shippingInformation.title',
        ), // t('deliveryForecast.header.shippingInformation.title')
        externalId: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.externalId',
          ), // t('deliveryForecast.header.shippingInformation.labels.externalId')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.company',
          ), // t('deliveryForecast.header.shippingInformation.labels.company')
        },
        department: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.department',
          ), // t('deliveryForecast.header.shippingInformation.labels.department')
        },
        name: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.name',
          ), // t('deliveryForecast.header.shippingInformation.labels.name')
        },
        phone: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.phone',
          ), // t('deliveryForecast.header.shippingInformation.labels.phone')
        },
        email: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.email',
          ), // t('deliveryForecast.header.shippingInformation.labels.email')
        },
        address: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.address',
          ), // t('deliveryForecast.header.shippingInformation.labels.address')
        },
        countryCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.countryCode',
          ), // t('deliveryForecast.header.shippingInformation.labels.countryCode')
        },
        vatNumber: {
          enabled: false,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.vatNumber',
          ), // t('deliveryForecast.header.shippingInformation.labels.vatNumber')
        },
        plant: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.plant',
          ), // t('deliveryForecast.header.shippingInformation.labels.plant')
        },
        unloadingPoint: {
          enabled: true,
          label: getTranslationsForConfig(
            'deliveryForecast.header.shippingInformation.labels.unloadingPoint',
          ), // t('deliveryForecast.header.shippingInformation.labels.unloadingPoint')
        },
      },
    },
    // 2 deliveryForecastInformation
    deliveryForecastInformation: {
      enabled: true,
      title: getTranslationsForConfig(
        'deliveryForecast.deliveryForecastInformation.title',
      ), // t('deliveryForecast.deliveryForecastInformation.title')
      scheduleAgreementNumber: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryForecastInformation.form.scheduleAgreementNumber.label',
        ), // t('deliveryForecast.deliveryForecastInformation.form.scheduleAgreementNumber.label')
      },
      currentReleaseDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryForecastInformation.form.currentReleaseDate.label',
        ), // t('deliveryForecast.deliveryForecastInformation.form.currentReleaseDate.label')
      },
      previousReleaseDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryForecastInformation.form.previousReleaseDate.label',
        ), // t('deliveryForecast.deliveryForecastInformation.form.previousReleaseDate.label')
      },
      confirmationCode: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryForecastInformation.form.confirmationCode.label',
        ), // t('deliveryForecast.deliveryForecastInformation.form.confirmationCode.label')
      },
      agreementType: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryForecastInformation.form.agreementType.label',
        ), // t('deliveryForecast.deliveryForecastInformation.form.agreementType.label')
      },
      currentReleaseNumber: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryForecastInformation.form.currentReleaseNumber.label',
        ), // t('deliveryForecast.deliveryForecastInformation.form.currentReleaseNumber.label')
      },
      previousReleaseNumber: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryForecastInformation.form.previousReleaseNumber.label',
        ), // t('deliveryForecast.deliveryForecastInformation.form.previousReleaseNumber.label')
      },
    },
    // 3 dataForConfirmation
    dataForConfirmation: {
      enabled: true,
      title: getTranslationsForConfig(
        'deliveryForecast.dataForConfirmation.title',
      ), // t('deliveryForecast.dataForConfirmation.title')
      responsePeriod: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.dataForConfirmation.form.responsePeriod.label',
        ), // t('deliveryForecast.dataForConfirmation.form.responsePeriod.label')
      },
      confirmationId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.dataForConfirmation.form.confirmationId.label',
        ), // t('deliveryForecast.dataForConfirmation.form.confirmationId.label')
        placeholder: getTranslationsForConfig(
          'deliveryForecast.dataForConfirmation.form.confirmationId.placeholder',
        ), // t('deliveryForecast.dataForConfirmation.form.confirmationId.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^.{1,20}$',
          regexErrorMessage: getTranslationsForConfig(
            'deliveryForecast.dataForConfirmation.form.confirmationId.errorMessage',
          ), // t('deliveryForecast.dataForConfirmation.form.confirmationId.errorMessage')
        },
      },
      department: {
        enabled: false,
        label: getTranslationsForConfig(
          'deliveryForecast.dataForConfirmation.form.department.label',
        ), // t('deliveryForecast.dataForConfirmation.form.department.label')
        readonly: false,
        validation: {},
      },
      contactName: {
        enabled: false,
        label: getTranslationsForConfig(
          'deliveryForecast.dataForConfirmation.form.contactName.label',
        ), // t('deliveryForecast.dataForConfirmation.form.contactName.label')
        readonly: false,
        validation: {},
      },
      contactPhone: {
        enabled: false,
        label: getTranslationsForConfig(
          'deliveryForecast.dataForConfirmation.form.contactPhone.label',
        ), // t('deliveryForecast.dataForConfirmation.form.contactPhone.label')
        readonly: false,
        validation: {
          regex: '^[0-9+() -]*$',
          regexErrorMessage: getTranslationsForConfig(
            'deliveryForecast.dataForConfirmation.form.contactPhone.errorMessage',
          ), // t('deliveryForecast.dataForConfirmation.form.contactPhone.errorMessage')
        },
      },
      contactMail: {
        enabled: false,
        label: getTranslationsForConfig(
          'deliveryForecast.dataForConfirmation.form.contactMail.label',
        ), // t('deliveryForecast.dataForConfirmation.form.contactMail.label')
        readonly: false,
        validation: {
          regex: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$',
          regexErrorMessage: getTranslationsForConfig(
            'deliveryForecast.dataForConfirmation.form.contactMail.errorMessage',
          ), // t('deliveryForecast.dataForConfirmation.form.contactMail.errorMessage')
        },
      },
    },
    // 4 deliveryScheduleDetails
    deliveryScheduleDetails: {
      enabled: true,
      title: getTranslationsForConfig(
        'deliveryForecast.deliveryScheduleDetails.title',
      ), // t('deliveryForecast.deliveryScheduleDetails.title')
      position: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.position.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.position.label')
      },
      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.buyerProductId.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.buyerProductId.label')
      },
      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.buyerProductDescription.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.buyerProductDescription.label')
      },
      confirmationProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.confirmationProductId.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.confirmationProductId.label')
      },
      scheduleLineQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.scheduleLineQuantity.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.scheduleLineQuantity.label')
      },
      cummulativeQuantityReceived: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.cummulativeQuantityReceived.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.cummulativeQuantityReceived.label')
      },
      modificationDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.modificationDate.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.modificationDate.label')
      },
      lastReceivingQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.lastReceivingQuantity.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.modificationDate.label')
      },
      plant: {
        enabled: false,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.plant.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.plant.label')
      },
      unloadingPoint: {
        enabled: false,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.form.unloadingPoint.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.form.unloadingPoint.label')
      },

      previousDeliveriesTable: {
        enabled: true,
        table: {
          enabled: true,
          columns: [
            {
              dataType: 'date',
              field: 'Date',
              filter: false,
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.date.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.date.header')
              sortable: true,
            },
            {
              dataType: 'string',
              field: 'DeliveryNoteNumber',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.deliveryNoteNumber.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.deliveryNoteNumber.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.deliveryNoteNumber.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.deliveryNoteNumber.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'Quantity',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.quantity.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.quantity.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.quantity.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.columns.quantity.header')
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.emptyMessageDetails',
          ), // t('deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.emptyMessageTitle',
          ), // t('deliveryForecast.deliveryScheduleDetails.previousDeliveries.table.emptyMessageTitle')
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'Date',
          sortOrder: 1,
        },
      },

      splitsTable: {
        enabled: true,
        table: {
          enabled: true,
          columns: [
            {
              align: 'right',
              dataType: 'forecastDate',
              field: 'ConfirmationDeliveryDate',
              filter: false,
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.confirmationDeliveryDate.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.confirmationDeliveryDate.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'ConfirmationDeliveryQuantity',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.confirmationDeliveryQuantity.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.confirmationDeliveryQuantity.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.confirmationDeliveryQuantity.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.confirmationDeliveryQuantity.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'BuyerDeliveryQuantity',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.buyerDeliveryQuantity.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.buyerDeliveryQuantity.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.buyerDeliveryQuantity.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.buyerDeliveryQuantity.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'CurrentCummulativeFigure',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.currentCummulativeFigure.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.currentCummulativeFigure.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.currentCummulativeFigure.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.currentCummulativeFigure.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'QuantityDeviation',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.quantityDeviation.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.quantityDeviation.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.quantityDeviation.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.quantityDeviation.header')
              sortable: true,
            },
            {
              dataType: 'string',
              field: 'Unit',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.unit.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.unit.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.unit.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.unit.header')
              sortable: true,
            },
            {
              dataType: 'status',
              field: 'Status',
              filter: true,
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.splits.table.columns.status.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.columns.status.header')
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecast.deliveryScheduleDetails.splits.table.emptyMessageDetails',
          ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecast.deliveryScheduleDetails.splits.table.emptyMessageTitle',
          ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.emptyMessageTitle')
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'ConfirmationDeliveryDate',
          sortOrder: 1,
        },
      },

      forecastsTable: {
        enabled: true,
        table: {
          enabled: true,
          columns: [
            {
              dataType: 'forecastDate',
              field: 'DeliveryDate',
              filter: false,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.deliveryDate.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.deliveryDate.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.deliveryDate.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.deliveryDate.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'DeliveryQuantity',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.deliveryQuantity.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.deliveryQuantity.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.deliveryQuantity.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.deliveryQuantity.header')
              sortable: true,
            },
            {
              align: 'right',
              dataType: 'number',
              field: 'CurrentCummulativeFigure',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.currentCummulativeFigure.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.currentCummulativeFigure.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.currentCummulativeFigure.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.currentCummulativeFigure.header')
              sortable: true,
            },
            {
              dataType: 'string',
              field: 'Unit',
              filter: true,
              filterPlaceholder: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.unit.filterPlaceholder',
              ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.unit.filterPlaceholder')
              header: getTranslationsForConfig(
                'deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.unit.header',
              ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.columns.unit.header')
              sortable: true,
            },
          ],
          emptyMessageDetails: getTranslationsForConfig(
            'deliveryForecast.deliveryScheduleDetails.forecasts.table.emptyMessageDetails',
          ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.emptyMessageDetails')
          emptyMessageTitle: getTranslationsForConfig(
            'deliveryForecast.deliveryScheduleDetails.forecasts.table.emptyMessageTitle',
          ), // t('deliveryForecast.deliveryScheduleDetails.forecasts.table.emptyMessageTitle')
          paginator: true,
          rows: 5,
          rowsPerPageOptions: [5, 20, 50],
          sortField: 'DeliveryDate',
          sortOrder: 1,
        },
      },
    },
    // 5 attachment
    attachment: {
      enabled: true,
      title: getTranslationsForConfig('deliveryForecast.attachment.title'), // t('deliveryForecast.attachment.title')
      // 5.1 documents
      documents: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecast.attachment.deliveryForecast.title',
        ), // t('deliveryForecast.attachment.deliveryForecast.title')
        columns: [
          {
            dataType: 'string',
            enabled: true,
            field: 'Name',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecast.attachment.deliveryForecast.table.columns.name.filterPlaceholder',
            ), // t('deliveryForecast.attachment.deliveryForecast.table.columns.name.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecast.attachment.deliveryForecast.table.columns.name.header',
            ), // t('deliveryForecast.attachment.deliveryForecast.table.columns.name.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'deliveryForecast.attachment.deliveryForecast.table.emptyMessageDetails',
        ), // t('deliveryForecast.attachment.deliveryForecast.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'deliveryForecast.attachment.deliveryForecast.table.emptyMessageTitle',
        ), // t('deliveryForecast.attachment.deliveryForecast.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Name',
        sortOrder: 1,
      },
      // 5.2 additionalDocuments
      additionalDocuments: {
        enabled: true,
        title: getTranslationsForConfig(
          'deliveryForecast.attachment.additionalDocuments.title',
        ), // t('deliveryForecast.attachment.additionalDocuments.title')
        columns: [
          {
            dataType: 'string',
            enabled: true,
            field: 'Name',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecast.attachment.additionalDocuments.table.columns.name.filterPlaceholder',
            ), // t('deliveryForecast.attachment.additionalDocuments.table.columns.name.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecast.attachment.additionalDocuments.table.columns.name.header',
            ), // t('deliveryForecast.attachment.additionalDocuments.table.columns.name.header')
            width: '400px',
          },
          {
            dataType: 'string',
            enabled: true,
            field: 'Category',
            header: getTranslationsForConfig(
              'deliveryForecast.attachment.additionalDocuments.table.columns.category.header',
            ), // t('deliveryForecast.attachment.additionalDocuments.table.columns.category.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'deliveryForecast.attachment.additionalDocuments.table.emptyMessageDetails',
        ), // t('deliveryForecast.attachment.additionalDocuments.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'deliveryForecast.attachment.additionalDocuments.table.emptyMessageTitle',
        ), // t('deliveryForecast.attachment.additionalDocuments.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Name',
        sortOrder: 1,
      },
    },
    // 6 editSplitItem
    editSplitItem: {
      enabled: true,
      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.buyerProductId.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.buyerProductId.label')
      },
      confirmationProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.confirmationProductId.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.confirmationProductId.label')
      },
      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.buyerProductDescription.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.buyerProductDescription.label')
      },
      buyerDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.buyerDeliveryDate.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.buyerDeliveryDate.label')
      },
      confirmationDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.confirmationDeliveryDate.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.confirmationDeliveryDate.label')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      buyerDeliveryQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.buyerDeliveryQuantity.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.buyerDeliveryQuantity.label')
      },
      confirmationDeliveryQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.confirmationDeliveryQuantity.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.edit.dialog.form.confirmationDeliveryQuantity.label')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
    // 7 infoSplitItem
    infoSplitItem: {
      enabled: true,
      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.buyerProductId.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.buyerProductId.label')
      },
      confirmationProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.confirmationProductId.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.confirmationProductId.label')
      },
      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.buyerProductDescription.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.buyerProductDescription.label')
      },
      buyerDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.buyerDeliveryDate.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.buyerDeliveryDate.label')
      },
      confirmationDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.confirmationDeliveryDate.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.confirmationDeliveryDate.label')
      },
      buyerDeliveryQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.buyerDeliveryQuantity.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.buyerDeliveryQuantity.label')
      },
      confirmationDeliveryQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.confirmationDeliveryQuantity.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.info.dialog.form.confirmationDeliveryQuantity.label')
      },
    },
    // 8 rejectSplitItem
    rejectSplitItem: {
      enabled: true,
    },
    // 9 acceptSplitItem
    acceptSplitItem: {
      enabled: true,
    },
    // 10 addSplitItem
    addSplitItem: {
      enabled: true,
      confirmationDeliveryDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.add.dialog.form.confirmationDeliveryDate.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.add.dialog.form.confirmationDeliveryDate.label')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      confirmationDeliveryQuantity: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.deliveryScheduleDetails.splits.table.add.dialog.form.confirmationDeliveryQuantity.label',
        ), // t('deliveryForecast.deliveryScheduleDetails.splits.table.add.dialog.form.confirmationDeliveryQuantity.label')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
    // 11 acceptDeliveryForecast
    acceptDeliveryForecast: {
      enabled: true,
      confirmationId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.title.send.dialog.form.confirmationId.label',
        ), // t('deliveryForecast.title.send.dialog.form.confirmationId.label')
      },
      confirmationDate: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.title.send.dialog.form.confirmationDate.label',
        ), // t('deliveryForecast.title.send.dialog.form.confirmationDate.label')
      },
      buyerProductId: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.title.send.dialog.shedules.positions.form.buyerProductId.label',
        ), // t('deliveryForecast.title.send.dialog.shedules.positions.form.buyerProductId.label')
      },
      buyerProductDescription: {
        enabled: true,
        label: getTranslationsForConfig(
          'deliveryForecast.title.send.dialog.shedules.positions.form.buyerProductDescription.label',
        ), // t('deliveryForecast.title.send.dialog.shedules.positions.form.buyerProductDescription.label')
      },
      table: {
        enabled: true,
        columns: [
          {
            dataType: 'date',
            field: 'ConfirmationDeliveryDate',
            header: getTranslationsForConfig(
              'deliveryForecast.title.send.dialog.shedules.positions.table.columns.confirmationDeliveryDate.header',
            ), // t('deliveryForecast.title.send.dialog.shedules.positions.table.columns.confirmationDeliveryDate.header')
          },
          {
            align: 'right',
            dataType: 'number',
            field: 'ConfirmationDeliveryQuantity',
            header: getTranslationsForConfig(
              'deliveryForecast.title.send.dialog.shedules.positions.table.columns.confirmationDeliveryQuantity.header',
            ), // t('deliveryForecast.title.send.dialog.shedules.positions.table.columns.confirmationDeliveryQuantity.header')
          },
          {
            align: 'right',
            dataType: 'number',
            field: 'BuyerDeliveryQuantity',
            header: getTranslationsForConfig(
              'deliveryForecast.title.send.dialog.shedules.positions.table.columns.buyerDeliveryQuantity.header',
            ), // t('deliveryForecast.title.send.dialog.shedules.positions.table.columns.buyerDeliveryQuantity.header')
          },
          {
            align: 'right',
            dataType: 'number',
            field: 'QuantityDeviation',
            header: getTranslationsForConfig(
              'deliveryForecast.title.send.dialog.shedules.positions.table.columns.quantityDeviation.header',
            ), // t('deliveryForecast.title.send.dialog.shedules.positions.table.columns.quantityDeviation.header')
          },
          {
            dataType: 'string',
            field: 'Unit',
            header: getTranslationsForConfig(
              'deliveryForecast.title.send.dialog.shedules.positions.table.columns.unit.header',
            ), // t('deliveryForecast.title.send.dialog.shedules.positions.table.columns.unit.header')
          },
          {
            dataType: 'status',
            field: 'Status',
            header: getTranslationsForConfig(
              'deliveryForecast.title.send.dialog.shedules.positions.table.columns.status.header',
            ), // t('deliveryForecast.title.send.dialog.shedules.positions.table.columns.status.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'deliveryForecast.title.send.dialog.shedules.positions.table.emptyMessageDetails',
        ), // t('deliveryForecast.title.send.dialog.shedules.positions.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'deliveryForecast.title.send.dialog.shedules.positions.table.emptyMessageTitle',
        ), // t('deliveryForecast.title.send.dialog.shedules.positions.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'ConfirmationDeliveryDate',
        sortOrder: 1,
      },
    },
  }
}
